<template>
  <i18n-t
    class="d-flex align-center justify-end ga-1 text-body-small text-medium-emphasis"
    keypath="texts.identification_by_deep_id"
    scope="global"
    tag="div"
  >
    <template #logo>
      <DeepAppLogo class="deepid-web-footer-logo" logo="deepid" />
    </template>
  </i18n-t>
</template>

<script setup lang="ts">
import { DeepAppLogo } from '@deepcloud/deep-ui-lib';
</script>

<style scoped lang="scss">
.deepid-web-footer-logo {
  height: 14px;
  width: auto;
}
</style>
